/**
 * Step 0: Início/Abertura
 * Apresentação do formulário
 */

import React, { useState, useEffect } from 'react';
import { StepContainer, TextBlock, StepNavigation } from '../components';
import { StepProps } from '../context';
import { set } from 'lodash';

const Step0_Inicio: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const [showNext, setShowNext] = useState(false);
  const [disableBtnContinue, setDisableBtnContinue] = useState(true);
  const [showSecondSegment, setShowSecondSegment] = useState(false);
  const [countdown, setCountdown] = useState(3);

  // Timer de 10 segundos
  useEffect(() => {
    if (countdown === 0) {
      setDisableBtnContinue(false);
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown]);

  const handleAccept = () => {
    setShowNext(true);
  };

  if (!showNext) {
    return (
      <StepContainer
        title=""
        description=""
      >
        {!showSecondSegment && (
          <>
            <p className='text-muted-foreground'>
              Olá, seja bem-vinda ao formulário de seleção para se tornar uma <b>Embaixadora</b> da X do Infinito!
            </p>
            <p>
              ✨ <b>Como funciona o Kit consignado:</b>
            </p>
            <p>
              ✅ Kit sem custo, <b>100% consignado;</b><br />
              ✅ <b>Acerto e troca do kit a cada 30 dias</b> (paga somente o que vender);<br />
              ✅ As peças são <b>hipoalergênicas</b>, com <b>altas camadas</b> de banho de ouro e prata;<br />
              ✅ Opções para <b>feminino, masculino e infantil</b>;<br />
              ✅ Comissões até <b>40%</b>;<br />
            </p>

            {/* <TextBlock
              type="paragraph"
              content="Este formulário levará alguns minutos para ser preenchido. Todas as informações são importantes para processar sua candidatura."
            /> */}

            <div style={{ marginTop: '1rem' }}>
              <button
                onClick={() => { setShowSecondSegment(true); setDisableBtnContinue(true); setCountdown(5); }}
                disabled={disableBtnContinue}
                className="btn-previous"
                style={{ width: '100%', padding: '12px 24px', fontSize: '16px' }}
              >
                Entendi! Quero continuar 🚀
              </button>
              {countdown > 0 && (
                <p className='w-full text-xs text-muted-foreground/30 text-center'>Aguarde {countdown}s</p>
              )}
            </div>
          </>
        )}


        <div className={`transition-all duration-500 ease-in-out ${showSecondSegment ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
          <img
            src="images/formulario/qvpya9wl80xjif5k7sjxct8v.jpg"
            alt="Plataforma exclusiva Xizinha"
            style={{ width: '100%', maxHeight: '400px', objectFit: 'contain', borderRadius: '8px' }}
          />
          <p className='font-semibold my-3'>📲 App Xizinha – Sua ferramenta de vendas:</p>
          <ul className='space-y-2 text-sm'>
            <li>💎 Vendas seguras via Pix (confirmação automática) ou cartão em até 5x sem juros.</li>
            <li>💎 Geração de certificado digital de garantia para suas clientes.</li>
            <li>💎 Relatórios, rankings e acompanhamento em tempo real.</li>
            <li>💎 Programa de Recompensas: você e suas clientes acumulam pontos e trocam por recompensas exclusivas.</li>
          </ul>

          <hr className="my-2" />
          <p className='text-muted-foreground text-xs'>
            Vale lembrar que essa aplicação NÃO GARANTE A SUA VAGA, e pode haver lista de espera.
            Portanto, vamos analisar seu pré cadastro e <b>entraremos em contato</b>. (somente acima de 18 anos)
          </p>
          <hr className="my-2" />

          <button
            onClick={handleAccept}
            className="btn-primary mt-4"
            disabled={disableBtnContinue}
            style={{ width: '100%', padding: '12px 24px', fontSize: '16px' }}
          >
            Vamos lá! 🚀
          </button>
          {countdown > 0 && (
            <p className='w-full text-xs text-muted-foreground/30 text-center'>Aguarde {countdown}s</p>
          )}

        </div>

      </StepContainer>
    );
  }

  return (
    <StepContainer title="" description="">
      <img
        src="images/formulario/idczvusw0v60decv3ggdrs4n.jpg"
        alt="Plataforma exclusiva Xizinha"
        style={{ width: '100%', maxHeight: '400px', objectFit: 'contain', borderRadius: '8px' }}
      />
      <p>
        <b>Se você realmente tem interesse</b> em alcançar ganhos financeiros infinitos e desvendar novos patamares com a revenda de semijoias, vamos começar! É só tocar no botão abaixo👇
      </p>
      <StepNavigation
        onNext={() => onNext({})}
        onPrevious={() => setShowNext(false)}
        nextLabel="Começar"
        previousLabel="Voltar"
        isLoading={isLoading}
        showPrevious={false}
      />
    </StepContainer>
  );
};

export default Step0_Inicio;
